/**
 * Single source of truth for money formatting across Oracul.
 *
 * Keitaro's tracker currency is EUR, and revenue/cost are stored as the raw
 * numbers Keitaro reports — there is no per-row currency column and no FX
 * conversion anywhere. So the whole app assumes one currency, defined here.
 * To switch the displayed currency, change APP_CURRENCY (and, if the tracker
 * itself changes currency, that is a data question, not just a display one).
 */
export const APP_CURRENCY = "EUR";
export const APP_LOCALE = "en-US";

/** A currency NumberFormat with APP_CURRENCY baked in; pass decimals etc. */
export const moneyFormatter = (
  options?: Intl.NumberFormatOptions,
): Intl.NumberFormat =>
  new Intl.NumberFormat(APP_LOCALE, {
    style: "currency",
    currency: APP_CURRENCY,
    ...options,
  });

/** Just the symbol (e.g. "€"), for chart axes and compact labels. */
export const CURRENCY_SYMBOL: string =
  moneyFormatter({ maximumFractionDigits: 0 })
    .formatToParts(0)
    .find((part) => part.type === "currency")?.value ?? APP_CURRENCY;
